module.exports = __webpack_public_path__ + "img/心血管功能.a8e79f76.png";